// The country the visitor picked is stored as whatever the regions endpoint calls the region,
// and one of those regions is "OTHER" - see the `=== 'OTHER'` checks in the product price and
// order pages. The consent journal wants ISO alpha-2 and validates the length, so sending
// "OTHER" earns a 422, and a 422 is terminal: the decision leaves the queue and never reaches
// the journal, while the banner closes as if it had. The field is optional in the contract,
// so an unusable value is left out rather than replaced with a guess - a made-up country in a
// log of legal evidence is worse than an absent one.
export function alpha2(value) {
  const code = String(value || '')
    .trim()
    .toUpperCase()

  return /^[A-Z]{2}$/.test(code) ? code : null
}

export function readCountry() {
  try {
    return alpha2(localStorage.getItem('country'))
  } catch (e) {
    return null
  }
}
